import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=713c9480&scoped=true"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=713c9480&prod&lang=scss"
import style1 from "./PatientDetails.vue?vue&type=style&index=1&id=713c9480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c9480",
  null
  
)

export default component.exports